import { createSchemaComponent } from '../../shared';
import { createElement } from 'react';
import { connect, mapProps, mapReadPretty } from '@formily/react';
import MonacoInput from './MonacoInput';
export const FormilyMonacoInput = connect(MonacoInput, mapProps((props, field) => {
    return {
        ...props,
        loading: field?.['loading'] || field?.['validating'],
    };
}), mapReadPretty((props) => {
    return createElement(MonacoInput, Object.assign({}, props, { readOnly: true }));
}));
export default createSchemaComponent({
    componentName: 'MonacoInput',
    component: FormilyMonacoInput,
});
